import { Alert, AlertTitle, Container, Stack } from "@mui/material";
import React, { useState } from "react";
import Header from "../components/common/Header";
import IntroCard from "../components/Cards/IntroCard";
import { Box, Typography } from "@mui/material";
import SubmitButton from "../components/common/SubmitButton";
//import Checkbox from '../components/Base/Checkbox/index';
import { useNavigate, useLocation } from "react-router-dom";
import Input from "../components/Base/Input/index";
import configData from "../Config";
import Backdrop from "../components/common/Backdrop";
import LoadingDots from "../components/Lottie/LoadingDots";
import { apis } from "../services/apiService";
import { onlyNumeric, validatePin } from "../utils/utils";
import styles from "../Style/Modules/organisationDetails.module.css";
import "../Style/Theme/index.css";
import AlertPopup from "../components/common/AlertPopup";

export default function OrganisationDetails() {
  const navigate = useNavigate();
  let location = useLocation();
  const initialdata = {
    TradeName: "",
    pAddress: "",
    pincode: "",
  };
  const [formData, setFormData] = useState(initialdata);
  const [addErr, setAddErr] = useState("");
  const [loading, setLoading] = useState(false);
  const [pinReq, setPinReq] = useState("");
  const [finalErr, setFinalErr] = useState("");

  const PinCode = {
    0: "Pin Code is required.",
    1: "Pin Code only in 6 digit.",
    2: "Only numbers are allowed.",
  };

  const handleOnChange = (e) => {
    setFormData({ ...formData, [e?.target?.name]: e?.target?.value });
    if (e?.target?.name === "pAddress") {
      if (e?.target?.value && e?.target?.value.length <= 10) {
        setAddErr("Address should be more than 10 character.");
      } else {
        setAddErr("");
      }
    }
    if (e?.target?.name === "pincode") {
      if (e?.target?.value && !onlyNumeric(e?.target?.value)) {
        setPinReq(PinCode[2]);
      } else if (e.target?.value?.length > 6 || e.target?.value?.length < 6) {
        setPinReq(PinCode[1]);
      } else if (e.target?.value?.length === 0) {
        setPinReq(PinCode[0]);
      } else {
        setPinReq("");
      }
    }
  };

  let handleSubmit = async (e) => {
    e.preventDefault();
    const reqData = {
      Pincode: formData?.pincode,
      ProgramName: location?.state?.program,
    };
    if ((await validatePin(reqData, setLoading, setFinalErr)) === true) {
      // console.log("check if true");
      try {
        setLoading(true);
        const reqData = {
          aid: location?.state?.AppId,
          tn: formData?.TradeName,
          ad: formData?.pAddress,
          pn: formData?.pincode,
        };

        let resp = await apis.postApi(
          configData.API_URL + "ApplicationFlow/AddOrganisationDetails",
          reqData
        );

        let result = await resp?.json();
        if (resp?.status === 200) {
          setLoading(false);
          let data = { AppId: location.state.AppId };
          navigate("/upload-proof", { state: data });
        }
      } catch (error) {
        setLoading(false);
        const errorResult = JSON.parse(error?.message);
        setFinalErr(errorResult?.statusMessage);
      }
    }
  };

  const validationFun = () => {
    if (
      !formData?.TradeName ||
      !formData?.pAddress ||
      !formData?.pincode ||
      addErr ||
      pinReq
    ) {
      return true;
    } else {
      return false;
    }
  };

  const handleClosedFunk = () => {
    setFinalErr("");
  };
  return (
    <>
      <Header showBar={true} step={3} />
      <Container maxWidth={false} className="container_Th">
        <IntroCard
          title="Organisation Details"
          subtitle="Commercial property address (in your city of business)"
          img="/assets/notepad.svg"
        />
        <form
          component="form"
          noValidate
          id="OrganisationDetails"
          onSubmit={handleSubmit}
          autoComplete="off"
          className={styles.orgDetailsForm}
        >
          <Box className={styles.orgDetailsBox}>
            <Input
              type="text"
              name="TradeName"
              label="Trade Name"
              autoComplete="off"
              value={formData?.TradeName}
              onChange={handleOnChange}
            />
            <Input
              type="textarea"
              name="pAddress"
              autoComplete="off"
              label="Property Address"
              value={formData?.pAddress}
              onChange={handleOnChange}
              disabled={!formData?.TradeName}
            />

            {addErr && (
              <Box mt={-3} ml={0}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {addErr}
                </Typography>
              </Box>
            )}

            <Input
              type="text"
              name="pincode"
              label="Pin Code"
              value={formData?.pincode}
              onChange={handleOnChange}
              disabled={!formData?.pAddress || addErr}
            />

            {pinReq && (
              <Box mt={-3} ml={0}>
                <Typography
                  variant="p"
                  color="subtitle"
                  className="errorMsg_Th"
                >
                  {/* Pincode is required */}
                  {pinReq}
                </Typography>
              </Box>
            )}
          </Box>
          {loading && (
            <Backdrop ax="center">
              <LoadingDots />
            </Backdrop>
          )}
          {finalErr && (
            <Backdrop ax="center">
              <AlertPopup finalErr={finalErr} handleClosed={handleClosedFunk} />
              ;
            </Backdrop>
          )}
          <SubmitButton hasNote="No" disabled={validationFun()} />
        </form>
      </Container>
    </>
  );
}
